<template>
    <b-navbar class="topHeader" >
        <div class="logoHeader">
            <b-navbar-brand v-if="bg==''" href="/dashboard">
                <img :src="logo" alt="Logo" height="35">
            </b-navbar-brand>
            <b-navbar-brand v-else href="#/dashboard">
                <img :src="logoW" alt="Logo" height="35">
            </b-navbar-brand>
        </div>
        <div class="menuHeader menuHeaderXS">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle> 
            <b-collapse is-nav id="nav_collapse" style="float:right;">
                <!-- <b-navbar-nav-toogle>  -->
                    <b-nav-item-dropdown right style="color:#555!important;">
                        <b-nav-item  v-if="this.userProfile.isAdmin" :class="{ active: $route.path === '/admin'}" href="/admin">{{ $t("messages.nav.dashboard") }}  </b-nav-item>
                        <!-- <b-nav-item :class="{ active: $route.path === '/dashboard'}" href="#/dashboard"> {{ $t("messages.nav.pools") }}</b-nav-item> -->
                        <b-nav-item v-if="this.userProfile.isAdmin" :class="{ active: $route.path === '/users'}" href="/users">{{ $t("messages.nav.admin-users") }}</b-nav-item>
                        <b-nav-item v-if="this.userProfile.isAdmin" :class="{ active: $route.path === '/pools'}" href="/pools">{{ $t("messages.nav.admin-pools") }} </b-nav-item>
                        <!-- Add pool -->
                        <b-nav-item class="featured" @click="$modal.show('add-pool');"> {{ $t("messages.addPool") }} <icon name="plus-circle"></icon> </b-nav-item>
                            
                        <b-nav-item-dropdown right>
                            <template slot="button-content">
                                <em>{{currentLanguage}}</em>
                            </template>
                            <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang" @click="setLang(lang.code)">{{ lang.name }}</b-dropdown-item>
                        </b-nav-item-dropdown>

                        <b-nav-item href="/profile"> {{ $t("messages.nav.profile") }}</b-nav-item>
                        <b-nav-item @click="logout"> {{ $t("messages.nav.logout") }}</b-nav-item>
                    </b-nav-item-dropdown>
                   
             <!-- </b-navbar-nav-toogle>  -->
            </b-collapse>
        </div>
  
        <div class="menuHeader menuHeaderXL">
            <b-navbar-nav>
                <b-nav-item v-if="this.userProfile.role == 'superadmin'" :class="{ active: $route.path === '/admin'}" href="/admin">Admin stats  </b-nav-item>
                <b-nav-item v-if="this.userProfile.role == 'superadmin'" :class="{ active: $route.path === '/query'}" href="/query">Query builder  </b-nav-item>
                <b-nav-item v-if="currentUser" :class="{ active: $route.path === '/dashboard'}" href="/dashboard"> {{ $t("messages.nav.pools") }}</b-nav-item>
                <b-nav-item v-if="this.userProfile.isAdmin" :class="{ active: $route.path === '/users'}" href="/users">{{ $t("messages.nav.admin-users") }}</b-nav-item>
                <b-nav-item v-show="this.userProfile.isAdmin" :class="{ active: $route.path === '/pools'}" href="/pools">{{ $t("messages.nav.admin-pools") }} </b-nav-item>
                <!-- Add pool -->
                <b-nav-item v-if="currentUser" class="featured" @click="$modal.show('add-pool'); welcome=false">{{ $t("messages.addPool") }} <icon name="plus-circle"></icon> </b-nav-item>
                <b-nav-item v-else href="/login"> {{ $t("messages.login.backToLogin") }}</b-nav-item>
            </b-navbar-nav>
            
            <b-navbar-nav class="toright">
                <b-nav-item-dropdown right>
                    <template slot="button-content">
                        <em>{{currentLanguage}}</em>
                    </template>
                    <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang" @click="setLang(lang.code)">{{ lang.name }}</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown right v-if="currentUser">
                    <template slot="button-content">
                        <em>{{ currentUser.email  }}</em>
                    </template>
                    <b-dropdown-item href="/profile"> {{ $t("messages.nav.profile") }}
                    
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="changeStyle"> {{ (bg === '') ? $t("messages.nav.solidBG")  : $t("messages.nav.poolBG") }}</b-dropdown-item> -->
                    <b-dropdown-item @click="logout"> {{ $t("messages.nav.logout") }}</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </div>
        <modal name="add-pool"
            height = "auto"
            :width = 600
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            :clickToClose="false">
            <div class="box-modal">
                <div slot="top-right">
                    <b-btn @click="onClose()" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
                </div>
                <el-row v-if="active == 0">
                    <el-col :span="24">
                        <el-row v-if="welcome" style="margin-bottom:8px;"><icon name="info-circle"></icon> {{ $t("messages.noPools") }} </el-row>
                        <el-row style="margin-bottom:8px;">{{ $t("messages.poolSubscribeInfo")}} </el-row>
                        <b-form-input type="text" v-model="newPoolId" :placeholder='$t("messages.nodeID")' maxlength="24"></b-form-input>
                        <b-col cols="9" v-if="message"><label class="error">{{ message }}</label></b-col>
                    </el-col>
                    <el-button style="margin-top: 12px;" @click="addPool" :disabled="newPoolId.length < 24">{{ $t("messages.validateID") }} </el-button>
                    <b-alert show variant="warning" style="margin-top:10px"> {{ $t("messages.nodeIDHelp") }} </b-alert> 
                </el-row>
                <el-row v-if="active == 1">
                    <b-alert show variant="success"><md-icon>info</md-icon>  {{ $t("messages.successfullAddedPool") }} </b-alert> 
                    <el-col :span="24">
                        <b-row class="mtop5">
                            <!-- Node ID -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.nodeID") }} </label></b-col>
                            <b-col cols="10"><b-form-input type="text" v-model.trim="detailPool.id" disabled></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop5">
                            <!-- Name -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.name") }} </label></b-col>
                            <b-col cols="10"><b-form-input type="text" :placeholder='$t("messages.login.name")' v-model.trim="detailPool.form.name"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop5">
                            <!-- Country -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.country") }} </label></b-col>
                            <b-col cols="10">
                                <b-form-select class="form-control"  v-model="detailPool.form.country" :options="countries"/>
                            </b-col>
                        </b-row>
                        <b-row class="mtop5">
                            <!-- City -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.city") }} </label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" :placeholder='$t("messages.city")' v-model.trim="detailPool.form.city"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop5">
                            <!-- Street -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.street") }} </label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" :placeholder='$t("messages.street")' v-model.trim="detailPool.form.street"></b-form-input></b-col>
                        </b-row>
                            <b-row class="mtop5">
                                <!-- Zip-code -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.zipCode") }} </label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" :placeholder='$t("messages.zipCode")' v-model.trim="detailPool.form.zipcode"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop5">
                            <!-- Latitude -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.latitude") }} </label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" ref="lat" :placeholder='$t("messages.latitude")' v-model="detailPool.form.lat"></b-form-input></b-col>
                        </b-row>
                        <b-row class="mtop5">
                            <!-- Longitude -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.longitude") }} </label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" :placeholder='$t("messages.longitude")' v-model="detailPool.form.lng"></b-form-input></b-col>
                        </b-row>
                        <div class="w100" style="padding:0 10px;">
                        <div style="width:48%;float:left;display:inline-block;">
                            <button @click="$modal.show('add-map');" class="button mtop20 w100 lessheight"> {{  $t("messages.updateLocation") }} <icon name="map-marker-alt" style="margin-left:10px;"></icon></button>
                        </div>
                        <div style="width:48%;float:right;display:inline-block;">
                        <!-- Save changes -->
                            <button @click="updatePool" class="button mtop20 w100 lessheight">{{ $t("messages.saveChanges") }}  <icon name="save" style="margin-left:10px;"></icon></button>
                        </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </modal>
        <modal name="add-map"
            transition="nice-modal-fade"
            :width = 650
            :height = 500
            :pivot-y="0.5"
            :adaptive="true"
            :reset="true"
            :clickToClose="false">
            <div class="box-modal">
                <div slot="top-right">
                    <b-btn @click="$modal.hide('add-map');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
                      <map-geo style="height:500px; width:650px" type="geo" :initial-pos="currentLocation" v-on:onSaveLocation="onSaveLocation"></map-geo>
                </div>

            </div>
        </modal>
        <modal name="inactivity"
            :width = 450
            :height = 200
            :pivot-y="0.5"
            :adaptive="true"
            :reset="true"
            :clickToClose="false">
            <div class="box-modal">
                <div slot="top-right">
                    <b-alert show variant="warning"><md-icon>info</md-icon> {{ $t("messages.inactivity") }} </b-alert>  
                    <b-button class="button mtop20 w100 lessheight" @click="reconnect">{{ $t("messages.reconnect") }}</b-button>
                </div>
            </div>
        </modal>
    </b-navbar>
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import MapGeo from './Map-geo.vue'

export default {
    components:{
        MapGeo
    },

    data() {
        return {
            show: true,
            welcome: false,
            logo:'',
            logoW:'',
            active: 0,
            newPoolId: '',
            detailPool: {
                form:{
                    lat:null,
                    lng:null
                }
            },
            message: null,
            currentLocation: {
                position:null
            }
        };
    },
    mounted() {
      this.showWelcome();
    },
    created(){
        let host = window.location.host.toLowerCase()
     
      switch(host){
        case 'www.da-gen.com':
        case 'da-gen.com':
            this.logo = require('@/assets/logos/dagen-nav.jpg') 
            this.logoW = require('@/assets/logos/dagen-nav.jpg') 
          break;
        case 'hayward.vistapool.es':
        case 'poolwatch.hayward.fr':
            this.logo = require('@/assets/logos/hayward-nav.png') 
            this.logoW = require('@/assets/logos/hayward-nav.png') 
          break;
        case 'kripsolpool.com':
        case 'www.kripsolpool.com':
             this.logo = require('@/assets/logos/kripsol-nav.jpg') 
             this.logoW = require('@/assets/logos/kripsol-nav.jpg') 
          break;
        case 'naturally-salt-poolaccess.de':
        case 'naturally-salt-poolaccess.eu':
        case 'naturally-salt-poolaccess.at':
        case 'naturally-salt-poolaccess.fr':
        case 'naturally-salt-poolaccess.es':
        case 'naturally-salt-poolaccess.com':
        case 'naturally-salt-poolaccess.net':
        case 'www.naturally-salt-poolaccess.de':
        case 'www.naturally-salt-poolaccess.eu':
        case 'www.naturally-salt-poolaccess.at':
        case 'www.naturally-salt-poolaccess.fr':
        case 'www.naturally-salt-poolaccess.es':
        case 'www.naturally-salt-poolaccess.com':
        case 'www.naturally-salt-poolaccess.net':
            this.logo = require('@/assets/logos/naturally-nav.png') 
            this.logoW = require('@/assets/logos/naturally-nav.png') 
          break;
        case 'app.brilix.com':
             this.logo = require('@/assets/logos/brilix.png') 
             this.logoW = require('@/assets/logos/brilix.png') 
          break;
          case 'compass-salt-water.com':
            this.logo = require('@/assets/logos/compass.png') 
            this.logoW = require('@/assets/logos/compass.png') 
        break;
        default:
        //this.logo = require('@/assets/logos/logo.png') 
        this.logo = require('@/assets/logos/logo-bgwhite.png') 
        this.logoW = require('@/assets/logos/logo-bgwhite.png') 
      }
      this.setCountries()
    },
    watch: {
        'userNotPresent': function() {
            if(this.userNotPresent){
                this.$modal.show('inactivity');
            }else{
                this.$modal.hide('inactivity');
            }
      
        }
    },
    computed: {
        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },

        countriesList: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].countries;
        },
        ...mapState(['currentUser','userProfile', 'languages','bg', 'userProfile','userNotPresent'])
    }, 
    methods: {
        setCountries(){
          this.countries = this.countriesList
        },
        reconnect() {
            this.$store.dispatch('reconnectPools')
        },
        showWelcome() {
            if(this.userProfile && this.userProfile.pools && this.userProfile.pools.length <=0){
                this.welcome = true;
                this.$modal.show('add-pool');
            } 
        },
        setLang(code){
            this.$i18n.locale = code
        },
        onClose() {
            this.$modal.hide('add-pool');
            this.active = 0;
            this.newPoolId = ''
            this.message = '';
            this.detailPool = null
        },
        addPool() {
            if(this.userProfile && this.userProfile.pools){
                let poolId = this.newPoolId.replace(/\s/g, "").toUpperCase();
                let exists = this.userProfile.pools.findIndex(x => x === poolId); 
                if(exists >= 0){
                    // Pool already assigned to user
                    this.message = this.$t("messages.poolAlreadyAssigned") 
                    return true;  
                } else {
                this.$store.dispatch('getPoolById', {'id': poolId }).then(response => {
                    if(response){
                        let data = response;
                        this.detailPool = data;
                        this.userProfile.pools.unshift(data.id);
                        this.$store.dispatch('updateProfile',this.userProfile).then(response => {
                            this.$store.dispatch('poolSubscribe',data.id).then(response => {
                                this.active = 1
                            },error => {
                                // Error subscribing pool
                                this.message = this.$t("messages.poolSubscribeError")
                            })
                        }, error => {
                            console.log(error)
                            // Error updating user pools
                            this.message = this.$t("messages.userPoolsUpdateError")
                        });
                    }else{
                        // The pool does not exist
                        this.message = this.$t("messages.poolNotExist")
                    }
                }, error => {
                    this.message = this.$t("messages.poolNotExist")
                })

                }
            } 
            
        },
        updatePool() {
            this.$snotify.async( '', '', () => new Promise((resolve, reject) => {
                this.$store.dispatch('updatePool', {
                    'id': this.newPoolId, 
                    'fields': this.detailPool
                }).then(response => {
                   resolve({
                    //    Pool updated
                        body: this.$t("messages.poolUpdated") ,
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                }, error => {
                    reject({
                        // Error updating pool
                        body: this.$t("messages.poolUpdateError"),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        },
        onSaveLocation(position) {
         
            if(position && this.newPoolId) {
                // Object.assign(this.detailPool.form, position);
                this.detailPool.form = Object.assign({}, this.detailPool.form, position)
                this.$refs.lat.$el.focus()
            }
           
            this.$modal.hide('add-map');
        },
        logout() {
            fb.auth.signOut().then(() => {
                this.$store.dispatch('clearData')
                this.$router.push('/login')
            }).catch(err => {
                console.log(err)
            })
        },        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue